import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Container = styled(Box)``;

export const Title = styled(Box)`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  padding: 0;
  margin: 0;
  height: 55px;
  border-bottom: 1.8px solid #323232;
  small {
    font-size: 14px;
  }
`;

export const HeaderTable = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 5px 0px 5px 60px;
`;

export const Typography = styled(Box)`
  margin-top: 17px;
  margin-bottom: 17px;
  height: 16px;
  width: 20vw;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 16px;
`;
